import { createBrowserHistory } from "history";

// We use a shared browser history to allow for multiple entry points.
if (!window.browserHistory) {
  window.browserHistory = createBrowserHistory({
    basename: "/app/v2.0",
  });
}

const history = window.browserHistory;
export default history;
